export default __webpack_public_path__ + "static/media/1314 knife block B side.a79f2799.png";